import React from 'react'
import useAuthStore from '../../store/authStore'

const RoleGate = ({ 
  allow, 
  children, 
  fallback = null, 
  showAccessDenied = false 
}) => {
  const { hasRole } = useAuthStore()

  if (!hasRole(allow)) {
    if (showAccessDenied) {
      return (
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
                Access Denied
              </h3>
              <p className="mt-1 text-sm text-yellow-700 dark:text-yellow-300">
                You don't have permission to view this content. Contact your administrator if you believe this is an error.
              </p>
            </div>
          </div>
        </div>
      )
    }
    
    return fallback
  }

  return children
}

export default RoleGate